import React from 'react';

import WebpImage from '@r1-frontend/ui-react/components/WebpImage';

import { IBanner } from '~/src/api/content/banners';

import * as ST from './styled';

interface IProps {
    routersBanners: IBanner[],
}

const RoutersBanners = ({ routersBanners }: IProps): JSX.Element => {
    return (
        <ST.RoutersBannersBlock>
            {routersBanners.map((elem) => !!elem.bannerInfo?.is_active && (
                <ST.ContentWrap
                    key={elem.bannerInfo?.id}
                    pngImg={elem.bannerInfo?.image_background}
                    webpImg={elem.bannerInfo?.image_background_webp}
                >
                    <ST.ImgBlock>
                        {elem.bannerInfo?.image && (
                            <WebpImage urlWebp={elem.bannerInfo?.image_webp}>
                                <ST.Image src={elem.bannerInfo.image}/>
                            </WebpImage>
                        )}
                    </ST.ImgBlock>
                    <ST.TextBlock>
                        <ST.Title textColor={elem.bannerInfo?.text_color}>{elem.bannerInfo?.title}</ST.Title>
                        <ST.SubText textColor={elem.bannerInfo?.text_color}>{elem.bannerInfo?.text}</ST.SubText>
                    </ST.TextBlock>
                </ST.ContentWrap>
            ))}
        </ST.RoutersBannersBlock>
    );
};

export default RoutersBanners;
